import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Button from "~/components-shared/Button";
import Modal from "~/components-shared/Modal";
import topicActionCreators from "~/store/topics/actions";
import topicSelectors from "~/store/topics/selectors";
import { usePostHog } from "posthog-js/react";
import { Card, Grid, Picture, Spinner, Text } from "~/components-shared";
import api from "~/lib/api";
import { TopicActionEnum } from "~/store/topics/types";
import { CRUDActionEnum, RoutesEnum } from "~/types/enums";
import styled from "styled-components";
import { genericColorCombination } from "~/lib/resolvers";
import StyledIcon from "~/components/StyledIcon";
const StyledPicture = styled(Picture)`
  background-size: 50%;
  border-radius: 32px;
  background-color: ${_ref => {
  let {
    theme
  } = _ref;
  return genericColorCombination(theme, "translucentPrimary").background;
}};
  color: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return genericColorCombination(theme, "translucentPrimary").color;
}};
  border: 3px solid ${_ref3 => {
  let {
    theme
  } = _ref3;
  return genericColorCombination(theme, "translucentPrimary").background;
}};
`;
const TopicPickTemplateModal = () => {
  const {
    t
  } = useTranslation();
  const action = useSelector(topicSelectors.getAction);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [templates, setTemplates] = useState([]);
  const history = useHistory();
  const posthog = usePostHog();
  useEffect(() => {
    if (action === TopicActionEnum.PICK_TEMPLATE) {
      setLoading(true);
      api.fetchTopicTemplates().then(response => {
        setTemplates(response);
      }).finally(() => {
        setLoading(false);
      });
    }
  }, [action]);
  const handleCancel = () => {
    dispatch(topicActionCreators.actionChanged(null, null));
    posthog.capture(`Topics Pick Template – Cancel`);
  };
  const handleCreate = () => {
    posthog.capture(`Topics Create – Create your own`);
    dispatch(topicActionCreators.actionChanged(CRUDActionEnum.CREATE, null));
    posthog.capture(`Topics Pick Template – Create your own`);
  };
  const handleRedirectTrends = () => {
    history.push(RoutesEnum.PRODUCT_TRENDS);
    dispatch(topicActionCreators.actionChanged(null, null));
  };
  const handleSelectTemplate = template => {
    dispatch(topicActionCreators.actionChanged(TopicActionEnum.CREATE_FROM_TEMPLATE, null, template));
    posthog.capture(`Topics Pick Template – From template: ${template.name}`);
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("TopicPickTemplateModal.selectTemplate"),
    onClose: handleCancel,
    fullWidth: true,
    fullHeight: true,
    maxWidth: "1200px"
  }, /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(Text, {
    element: "h5",
    weight: "regular",
    color: "textSecondary",
    s: {
      mb: 5,
      px: 3
    }
  }, t("TopicPickTemplateModal.description")), loading ? /*#__PURE__*/React.createElement(Spinner, {
    s: {
      mt: 3
    },
    center: true
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    s: {
      py: 10,
      mx: 4
    },
    key: 1,
    color: "background",
    onClick: () => handleCreate(),
    shadow: true,
    align: "center"
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    src: "sparkles",
    s: {
      mb: 6
    }
  }), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    s: {
      mb: 1
    }
  }, "+ ", t("TopicPickTemplateModal.createYourOwnTopic"))), /*#__PURE__*/React.createElement(Grid, {
    cols: 4,
    equal: true,
    gap: 8,
    s: {
      px: 4,
      py: 6,
      pb: 8
    },
    align: "stretch"
  }, templates.map(template => /*#__PURE__*/React.createElement(Card, {
    s: {
      px: 5,
      py: 10
    },
    key: template.id,
    onClick: () => handleSelectTemplate(template),
    color: "background",
    shadow: true,
    align: "center"
  }, /*#__PURE__*/React.createElement(StyledPicture, {
    src: template.lightThemeImage,
    width: "6rem",
    height: "6rem",
    s: {
      mb: 6
    },
    backgroundSize: "contain"
  }), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    s: {
      mb: 2
    }
  }, template.name)))))), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: handleCancel,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "grey",
    s: {
      px: 8,
      ml: 2
    },
    onClick: handleRedirectTrends,
    rounded: true
  }, t("TopicPickTemplateModal.viewCurrentTopics"))));
};
export default TopicPickTemplateModal;